import { ShortCode } from '@highereducation/wordpress';
import { SliderImage } from '@highereducation/hen-ui';

type SliderImageShortcodeProps = {
  src?: string;
  alt?: string;
  width?: string;
  height?: string;
};

/**
 * SliderImageShortcode - Shortcode wrapper for SliderImage composite component
 *
 * Handles prop conversion from WordPress shortcode attributes (strings) to
 * component props (typed values).
 *
 * SliderImage is a composite component that applies the necessary className
 * and wrapper structure to ensure images display correctly within ImageGrid's
 * slider layout.
 *
 * Supported shortcode attributes:
 * - src: string (required) - Image source URL
 * - alt: string (optional) - Alt text for the image
 * - width: number (optional) - Image width
 * - height: number (optional) - Image height
 *
 * @example WordPress shortcode usage:
 * [hen-ui-slider-image src="/path/to/image.png" alt="Image description" /]
 *
 * @example Component usage:
 * <SliderImage src="/path/to/image.png" alt="Image description" />
 */
export const SliderImageShortcode: ShortCode<SliderImageShortcodeProps> = {
  component: ({ src, alt, width, height }) => {
    if (!src) {
      console.warn('SliderImageShortcode: src is required');
      return null;
    }

    // Parse width and height to numbers
    const parsedWidth = width ? parseInt(width, 10) : undefined;
    const parsedHeight = height ? parseInt(height, 10) : undefined;

    return (
      <SliderImage
        src={src}
        alt={alt}
        width={parsedWidth}
        height={parsedHeight}
      />
    );
  },
};
